<div class="batch-order-item-list">
  <div class="mbp-table-wrap">
    <table mat-table matSort [dataSource]="orderItems" class="mbp-data-table batch-order-item-list__table">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef class="name-col">Name</th>
        <td mat-cell *matCellDef="let item" class="name-col">
          {{ item.medicine_dosage_package_type.label_name ? item.medicine_dosage_package_type.label_name : '—' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="quantity">
        <th mat-header-cell *matHeaderCellDef>Quantity</th>
        <td mat-cell *matCellDef="let item">{{ item.medicine_dosage_package_type.contained_quantity }}</td>
      </ng-container>

      <ng-container matColumnDef="fulfilled">
        <th mat-header-cell *matHeaderCellDef>Fulfilled</th>
        <td mat-cell *matCellDef="let item">{{ item.batch_items.length }}</td>
      </ng-container>

      <ng-container matColumnDef="details">
        <th mat-header-cell *matHeaderCellDef class="actions-col">&nbsp;</th>
        <td mat-cell *matCellDef="let item" class="actions-col">
          @if (order) {
            <button type="button" mat-stroked-button class="batch-order-item-list__action" (click)="openDetails(item)">
              <mat-icon>info</mat-icon>
              Details
            </button>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</div>
